export const getHideLogo = (country: string | undefined) => {
  return !country || country === 'US' || country === 'CAN' || country === 'ALL'
}
